import { api } from 'common';

import { FormBlockFormFields } from './FormFields';
import { getDefaultSchedulingConfigs } from './SchedulingConfigs/utils';
import { formBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const formConfig: BlockConfigProps<api.FlowDefinition.FormBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'form',
  defaultConfig: {
    runMode: api.FlowDefinition.RunMode.Live,
    exportMode: api.PrevisitForm.ExportMode.RunAutoExport,
    formTemplateConfigs: [],
    schedulingConfigs: getDefaultSchedulingConfigs(),
    isOverridingEntity: false,
  },
  configFields: {
    schema: api.FlowDefinition.FormBlockConfigSchema,
    FormFields: FormBlockFormFields,
  },
  documentationMarkdown: formBlockDocumentationMarkdown,
};
